import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Booking from './pages/Booking';
import MyBookings from './pages/MyBookings';
import FacebookFeed from './pages/FacebookFeed';
import TikTokFeed from './pages/TikTokFeed';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book/:roomId" element={<Booking />} />
            <Route path="/my-bookings" element={<MyBookings />} />
            <Route path="/facebook" element={<FacebookFeed />} />
            <Route path="/tiktok" element={<TikTokFeed />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </Router>
  );
}

export default App;